import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useContent } from "../../Core/Content/Provider";
import "../../Features/Home/home.css";
import "./cinema-theme.css";

const links = [
  { to: "/services", label: "Services" },
  { to: "/packages", label: "Packages" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/about", label: "About" },
  { to: "/this-is-me", label: "This is me" },
];
interface CinemaHeaderProps {
  search?: string;
  onSearchChange?: (value: string) => void;
  onSearch?: () => void;
}
export function CinemaHeader({ search = "", onSearchChange, onSearch }: CinemaHeaderProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);
  return <header className="cinema-nav">
    <Link to="/" className="cinema-wordmark" aria-label="CMJ Cinema home"><img src="/cmj-cinema-logo.png" alt=""/><span>cmj<span className="wordmark-dot">.</span><small>cinema</small></span></Link>
    <nav className="cinema-nav-links" aria-label="Main navigation">{links.map(link => <NavLink key={link.to} to={link.to}>{link.label}</NavLink>)}</nav>
    {onSearchChange ? <form className="cinema-search" role="search" onSubmit={event => { event.preventDefault(); onSearch?.(); }}>
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" stroke="currentColor" strokeWidth="1.5"/><path d="m16 16 5 5" stroke="currentColor" strokeWidth="1.5"/></svg>
      <input aria-label="Search visual inspiration" placeholder="Find your inspiration" value={search} onChange={event => onSearchChange(event.target.value)}/><kbd>↵</kbd>
    </form> : <span className="cinema-nav-note">Stories. Brands. Moments.</span>}
    <NavLink className="cinema-contact-link" to="/contact">Let’s talk</NavLink>
    <Link className="cinema-pill cinema-pill-dark nav-book" to="/booking">Book a shoot <span aria-hidden="true">↗</span></Link>
    <button type="button" className="cinema-menu-toggle" aria-label="Toggle navigation" aria-expanded={menuOpen} aria-controls="cinema-mobile-nav" onClick={() => setMenuOpen(value => !value)}>{menuOpen ? "Close" : "Menu"}</button>
    {menuOpen && <nav id="cinema-mobile-nav" className="cinema-mobile-nav" aria-label="Mobile navigation"><NavLink to="/">Home</NavLink>{links.map(link => <NavLink key={link.to} to={link.to}>{link.label}</NavLink>)}<NavLink to="/contact">Contact</NavLink><Link to="/booking">Book a shoot ↗</Link></nav>}
  </header>;
}
export function CinemaFooter() {
  const content = useContent("footer");
  return <footer className="cinema-footer">
    <div className="cinema-footer-top"><Link to="/" className="cinema-footer-wordmark">cmj<span>.</span>cinema</Link><p>{content.tagline}</p><Link className="cinema-pill cinema-pill-outline" to="/booking">Let’s create together <span aria-hidden="true">↗</span></Link></div>
    <nav className="cinema-footer-links" aria-label="Footer navigation">{links.map(link => <Link key={link.to} to={link.to}>{link.label}</Link>)}<Link to="/contact">Contact</Link></nav>
    <div className="cinema-footer-bottom"><span>© {new Date().getFullYear()} CMJ Cinema</span><a href={`mailto:${content.email}`}>{content.email}</a><a href={`tel:${content.phone}`}>{content.phone}</a><Link to="/dashboard">Studio login <span aria-hidden="true">↗</span></Link></div>
  </footer>;
}
